import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility';

const initialState = {
  admins: null,
  count: null,
  pageS: 2,
  openAdminId: null,
  loading: null,
  error: null,
};

const openAdmin = (state, action) => {
  return updateObject(state, { openAdminId: action.adminId });
};

const fetchAdminsStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchAdminsSuccess = (state, action) => {
  return updateObject(state, {
    count: action.count,
    admins: action.admins,
    error: null,
    loading: false,
  });
};

const fetchAdminsFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// delete admin
const deleteAdminSuccess = (state, action) => {
  const updatedArray = state.admins.filter(
    (admin) => admin._id !== action.adminId
  );
  // console.log(updatedArray);
  return updateObject(state, {
    admins: updatedArray,
    error: null,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ADMIN_ID:
      return openAdmin(state, action);

    case actionTypes.FETCH_ADMINS_START:
      return fetchAdminsStart(state, action);
    case actionTypes.FETCH_ADMINS_SUCCESS:
      return fetchAdminsSuccess(state, action);
    case actionTypes.FETCH_ADMINS_FAIL:
      return fetchAdminsFail(state, action);

    case actionTypes.DELETE_ADMIN_SUCCESS:
      return deleteAdminSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
